import { render } from "./cipboardParagraph.vue?vue&type=template&id=20ef2b27"
import script from "./cipboardParagraph.vue?vue&type=script&lang=js"
export * from "./cipboardParagraph.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__